module.exports = __webpack_public_path__ + "img/sy_n5.f994cd82.jpg";